export default "<div>{{ GetReleveCompteurType(id) }}</div>";